import { FC } from 'react';
import { IFeeling } from '../model/ICheckin';
import { IThemeColor } from '../../theme/IThemeColor';
import {
    IIconSize,
    IconComponent,

    HappyIcon,
    MehIcon,
    SadIcon,
    VeryHappyIcon,
    VerySadIcon,

    DuoHappyIcon,
    DuoVeryHappyIcon,
    DuoMehIcon,
    DuoSadIcon,
    DuoVerySadIcon
} from '../../theme/Icons';
import { FeelingSVGIcon } from './FeelingSVGIcon';

// regular, not filled in
const FEELING_ICONS: {[feeling in IFeeling]: IconComponent} = {
    1: VeryHappyIcon,
    2: HappyIcon,
    3: MehIcon,
    4: SadIcon,
    5: VerySadIcon
};

// solid, filled in
export const SOLID_FEELING_ICONS: {[feeling in IFeeling]: IconComponent} = {
    1: DuoVeryHappyIcon,
    2: DuoHappyIcon,
    3: DuoMehIcon,
    4: DuoSadIcon,
    5: DuoVerySadIcon
};

export const FEELING_COLORS: {[feeling in IFeeling]: IThemeColor} = {
    1: 'theme-dark-green',
    2: 'theme-teal',
    3: 'theme-purple',
    4: 'theme-red-orange',
    5: 'theme-red'
};

export type IFeelingIconProps = {
    feeling: IFeeling;

    // currently only pertains to NON SVG
    size?: IIconSize;
    noColor?: boolean;
    solid?: boolean;

    // only SVG
    isSVG?: boolean;
    svgLayout?: {
        x?: number;
        y?: number;
        width?: number;
        height?: number;
    }
};

export const FeelingIcon: FC<IFeelingIconProps> = ({ feeling, noColor, size, solid, isSVG, svgLayout }) => {
    const iconSet = solid ? SOLID_FEELING_ICONS : FEELING_ICONS;
    const Icon = iconSet[feeling || 0];
    const color = !noColor ? FEELING_COLORS[feeling || 0] : 'medium';

    return isSVG ? (
        <FeelingSVGIcon feeling={feeling} {...svgLayout} />
    ) : (
        <span data-id={`feeling-${feeling}-icon`}>
            <Icon color={color} size={size} />
        </span>
    );
};
